
































































































import {Component, Vue} from "vue-property-decorator";
import SearchSegmentation from "@/views/SearchSegmentation.vue";
import {integer} from "@/components/filters/Integer";
import {NullPointerException, StateMachine} from "frontend-core";
import {SegmentationCopyRuleTypeEnum} from "@/modules/Segmentation/models/SegmentationCopyEnum";
import {SegmentRule} from "@/modules/Segmentation/models/SegmentRule";
import {AntiSegmentRule} from "@/modules/Segmentation/models/AntiSegmentRule";
import {Agent} from "@/models/Agent";
import {ISegmentationTargetService} from "@/modules/Segmentation/services/ISegmentationTargetService";
import {container} from "@/services/registerServiceProvider";
import {ValidationException} from "@/models/ValidationException";

@Component({
    components: {SearchSegmentation},
    filters: {
        int: integer
    },
})
export default class DeleteRule extends Vue {
    readonly stateMachine: StateMachine = new StateMachine("idle", {
        idle: ["loading"],
        loading: ["idle"],
    });
    readonly ruleTypes: readonly string[] = Object.values(SegmentationCopyRuleTypeEnum);
    ruleType: SegmentationCopyRuleTypeEnum = SegmentationCopyRuleTypeEnum.antisegment;
    rule: SegmentRule | AntiSegmentRule = new AntiSegmentRule();
    selectedArray: Agent[] = [];
    progress: number = 0;

    private readonly segmentationTargetService: ISegmentationTargetService = container.resolve("ISegmentationTargetService");

    async submit(): Promise<void> {
        if (!this.rule.title) {
            this.rule.errors.title = ["Введите название правила"];
        } else if (this.rule.errors.title.length === 0) {
            this.stateMachine.transition("loading");
            const totalLength: number = this.selectedArray.length;
            this.progress = 0;

            const agentArrayToCopy = this.selectedArray.slice();

            while (agentArrayToCopy.length > 0 && this.stateMachine.state === "loading") {
                let subOperationsCount: number = 3;
                let subOperationsCompleted: number = 0;

                const progressPartial: number = 1 / totalLength * 100;

                const agent: Agent = agentArrayToCopy[0];

                let progressWas: number = this.progress;

                const segmentation = await this.segmentationTargetService.getByAgentId(agent.id);

                if (!segmentation) {
                    throw new NullPointerException();
                }

                subOperationsCompleted += 1;
                this.progress = progressWas + this.incrementProgress(
                    subOperationsCompleted,
                    subOperationsCount,
                    progressPartial,
                );

                if (segmentation.parentId) {
                    subOperationsCount += 1;

                    progressWas = this.progress;

                    await this.segmentationTargetService.unLock(segmentation);

                    subOperationsCompleted += 1;
                    this.progress = progressWas + this.incrementProgress(
                        subOperationsCompleted,
                        subOperationsCount,
                        progressPartial,
                    );
                }

                let index: number;

                if (this.rule instanceof AntiSegmentRule) {
                    index = segmentation.antiSegments.map(i => i.title).indexOf(this.rule.title);

                    if (index > -1) {
                        segmentation.antiSegments.splice(index, 1);
                    }
                } else {
                    index = segmentation.segments.map(i => i.title).indexOf(this.rule.title);

                    if (index > -1) {
                        segmentation.segments.splice(index, 1);
                    }
                }

                if (index === -1) {
                    this.rule.errors.title = [`У ${agent.name} нет такого правила`];
                }

                if (this.rule.errors.title.length !== 0) {
                    this.cancel();
                    throw new ValidationException("Название правила");
                }

                await this.segmentationTargetService.update(segmentation);

                agentArrayToCopy.splice(agentArrayToCopy.indexOf(agent), 1);

                this.progress = 100 * (totalLength - agentArrayToCopy.length) / totalLength;
            }

            this.stateMachine.transition("idle");
        }
    }

    setSelectedArray(val: unknown[]): void {
        this.selectedArray.splice(
            0,
            this.selectedArray.length,
            ...val.filter<Agent>((i): i is Agent => i instanceof Agent),
        );

        if (this.rule) {
            this.rule.errors.title = [];
        }
    }

    selectRuleType(): void {
        if (this.ruleType === SegmentationCopyRuleTypeEnum.antisegment) {
            this.rule = new AntiSegmentRule();
        } else {
            this.rule = new SegmentRule();
        }
    }

    close(): void {
        this.$emit('close');
    }

    selectAgent(agent: Agent) {
        if (!this.selectedArray.map(i => i.id).includes(agent.id)) {
            this.selectedArray.push(agent);
        }
    }

    toIdle(e: boolean): void {
        if (!e) {
            this.stateMachine.transition("idle");
        }
    }

    cancel(): void {
        this.stateMachine.transition("idle");
    }

    private incrementProgress(
        subOperationsCompletedLength: number,
        subOperationsCount: number,
        operationProgress: number,
    ): number {
        return subOperationsCompletedLength / subOperationsCount * operationProgress;
    }
}
